import React from 'react'

import GroupForm from '/components/groups/form/GroupForm'

import './CreateGroup.css'

const CreateGroup = function() {

    return (
        <div className="create-group">
            <GroupForm />
        </div>
    )
}

export default CreateGroup
